import React, { useState, useEffect } from 'react'
import { Row, Form, Button, Col } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { toast } from 'react-toastify';
import { useGetallqandaQuery } from '../../slices/teachers/teacherQuestionsApiSlice';
import { useGetPublicsubjectQuery } from '../../slices/teachers/subjectApiSlice';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import NoQuestions from '../../components/NoQuestions';
import TeacherOldQuestion from '../../components/TeacherOldQuestion';
import PaginateOldAnswers from '../../components/PaginateOldAnswers';

const TeacherPreviousAnswers = () => {

    const navigate = useNavigate();
    const { id, pageNumber } = useParams();

    const [subjecttittle, setSubjecttittle] = useState('');
    const [teachername, setTeachername] = useState('');

    const { teacherInfo } = useSelector((state) => state.authTeacher);
    
    const { data } = useGetPublicsubjectQuery(id);

    const { data: allQandA, isLoading, error  } = useGetallqandaQuery({id, pageNumber});

    useEffect(() => {
        setSubjecttittle(data?.tittle)
    }, [data])

    useEffect(() => {
        if(!teacherInfo) {
            navigate('/teacherlogin')
        }
        if(teacherInfo) {
            setTeachername(teacherInfo.firstname + ' ' + teacherInfo.lastname);
        }
    }, [navigate, teacherInfo])

  return (
    <div>
        <TeacherNavbar />
        <div className="main-content" id="panel">
            <TeacherHeader /><br /><br /><br />      
            <div className="container-fluid mt--6">
                {isLoading ? ( 
                    <Loader />
                ) : error ? (
                    <Message variant='danger'>
                        {error?.data?.message || error.error}
                    </Message>
                ) : (
                    <div className="row">
                        <div className="col-xl-12 questionTitle timeline244 oldQt2">   
                            <h4>  <span className='tittleColor4 oldQt2' style={{textTransform: 'capitalize'}}>
                                {subjecttittle}
                            </span></h4>
                        </div>
                        {allQandA?.newArr3?.map((question, index) => (
                            <div className=" offset-md-1 col-md-7  " key={index}>   
                                <div className="card timeline24">                
                                    <div className="card-body  ">
                                        <div className="timeline22 item-container2 " data-timeline-content="axis" data-timeline-axis-style="dotted">                       
                                        <div className='timeline-block timeP2 item item22' key={question._id} >  
                                            <TeacherOldQuestion question={question} teachername={teachername} className="" />                 
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {allQandA?.newArr3?.length === 0 && (
                            <div  className="col-md-6 col-xl-4 ">  
                                <NoQuestions />
                            </div>
                        )}
                        <PaginateOldAnswers
                            pages={allQandA?.pages}
                            page={allQandA?.page}
                            link='teacherpreviousanswers'
                            id={id}
                            /><br /><br />
                    </div>
                )} 
            </div>
        </div>
    </div>
  )
}

export default TeacherPreviousAnswers
